// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__i0Kv6","validationTips":"StatementDescriptor_validationTips__1gPtM"};